import { useMemo } from 'react';
import concat from 'lodash/concat';

import { UseFilterValuesType } from '@/components/FilterNew/types';
import { useFilesQuery } from '@/modules/tasks/views/TasksDashboard/graphql/queries/generated/files';

import { getFilesFilterOption } from '../utils';

const EMPTY_ARRAY: never[] = [];

const useFilesFilterValue: UseFilterValuesType = ({ value }) => {
  const [{ fetching, data }] = useFilesQuery({
    variables: { filters: { fileIds: value }, first: value.length },
    pause: !value.length,
  });

  const selectedOptions = useMemo(() => {
    if (!value.length) {
      return EMPTY_ARRAY;
    }

    const selectedSystemGeneratedFiles =
      data?.systemGeneratedFiles?.edges
        ?.filter(({ node }) => value.includes(node.id))
        ?.map(({ node }) => node) || [];

    const selectedFiles = data?.files?.edges?.map(({ node }) => node) || [];

    const selectedOptions = concat(
      selectedSystemGeneratedFiles?.map(getFilesFilterOption),
      selectedFiles?.map(getFilesFilterOption),
    );

    return selectedOptions;
  }, [data?.files?.edges, data?.systemGeneratedFiles?.edges, value]);

  return { fetching, resolvedValue: selectedOptions?.map(({ label }) => label), selectedOptions };
};

export default useFilesFilterValue;
